import { useTranslation } from 'react-i18next';
const NoData = () => {
  const { t } = useTranslation();
  return <div>{t('general.dataStates.noresults')}</div>;
};
export default NoData;
